import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-parameters-card',
  templateUrl: './turns-parameters-card.component.html',
  styleUrls: ['./turns-parameters-card.component.scss']
})
export class TurnsParametersCardComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
